<div class="wrapper">
  <div class="container">
    <div class="container-fluid p-0">
      <!-- header -->
      <app-header></app-header>

      <!-- content -->
      <main>
        <router-outlet></router-outlet>
      </main>

      <!--faqHeader-->
      <!-- <app-faq-footer></app-faq-footer> -->

      <!-- footer -->
      <app-footer></app-footer>

      <!-- Lateral button informations -->
      <!-- <app-education-side-buttons></app-education-side-buttons> -->
    </div>
  </div>
</div>
